import { fabric } from "fabric";
import { CanvasHandler } from "../../handlers";
import { FabricEvent } from "../../types/FabricCustomType";
import { IObjectDesingner } from "../../types/HandlerObjectType";
import { ActiveSelectionProperties } from "./properties";

class ActiveSelection extends ActiveSelectionProperties implements IObjectDesingner {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
  }

  public onInit() {
    this.canvasHandler.interactionHandler.drawing("activeSelection", "crosshair");
    this.canvasHandler.activeShape = null;
  }

  public onMouseDblClick(event: FabricEvent<Event>) {
  }

  public onMousedown(event: FabricEvent<MouseEvent>) {

  }

  public onMousemove(event: FabricEvent<MouseEvent>) {
  }

  public onMouseup(event: FabricEvent<MouseEvent>) {
  }

  public onRotated(event: FabricEvent) {
    const { target } = event;
    this.canvasHandler.canvas.discardActiveObject();
    const rows = target.getObjects().filter((obj: any) => obj.superType === "row");
    rows.forEach((row: any) => {
      this.canvasHandler.drawingHandler.updateRowRotation(row);
    });
    const activeSelection = new fabric.ActiveSelection(target.getObjects(), {
      canvas: this.canvasHandler.canvas
    });
    this.canvasHandler.canvas.setActiveObject(activeSelection);
    this.canvasHandler.canvas.renderAll();
    this.canvasHandler.drawingHandler.setType('activeSelection');
  }
}
export default ActiveSelection;
